import { parseFssOpsToolCall } from "@mirage/mosaics/Chat/components/chat/ConversationMessages/ToolCalls/fss/parsers";
import type { ParsedToolCall } from "@mirage/mosaics/Chat/components/chat/ConversationMessages/ToolCalls/types";
import type { AgentId, ToolCall } from "@mirage/service-conversation/types";

/**
 * Parse a tool call into an understood tool call type.
 * @param toolCall The tool call to parse.
 * @returns The parsed tool call; undefined if it is not a recognizable client-side tool.
 */
export function parseToolCall(
  toolCall: ToolCall,
  agentId: AgentId | undefined,
): ParsedToolCall | undefined {
  switch (agentId) {
    case "fss_ops":
      return parseFssOpsToolCall(toolCall, agentId);
    default:
      return undefined;
  }
}
